import { styled } from 'linaria/react';
import React from 'react';
import { ReactComponent as Carrot } from '../svg/Carrot.svg';
import { ReactComponent as Check } from '../svg/Check.svg';
export const SelectContainer = /*#__PURE__*/styled('div')({
  name: "SelectContainer",
  class: "s179eesq"
});
export const ListItem = /*#__PURE__*/styled('button')({
  name: "ListItem",
  class: "l1hrnbpy"
});
export const SelectableListItem = /*#__PURE__*/styled(ListItem)({
  name: "SelectableListItem",
  class: "s158lffz"
});
export const ListTitle = /*#__PURE__*/styled('h4')({
  name: "ListTitle",
  class: "l1s70pqm"
});
export const SelectItem = /*#__PURE__*/styled('span')({
  name: "SelectItem",
  class: "sn989z3"
});
export const SelectItemWrapper = /*#__PURE__*/styled('span')({
  name: "SelectItemWrapper",
  class: "s1gflhlg"
}); // TODO: animate height to auto

export const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "wocpl1j"
});
const InnerWrapper = /*#__PURE__*/styled('div')({
  name: "InnerWrapper",
  class: "igp80ol"
});
export const DropdownWrapper = ({
  isOpen,
  children
}) => React.createElement(Wrapper, {
  className: isOpen ? 'open' : 'closed'
}, React.createElement(InnerWrapper, null, children));
export const StyledCarrot = /*#__PURE__*/styled(Carrot)({
  name: "StyledCarrot",
  class: "s1b54bhs"
});
export const StyledCheck = /*#__PURE__*/styled(Check)({
  name: "StyledCheck",
  class: "s18v80j2"
});

require("../../../../.linaria-cache/node_modules/@jetshop/ui/Select/Components.linaria.css");